export default "__VITE_ASSET__CPreUCVG__";